export enum ListPageType {
	AUTHOR = 'author',
	BLOG = 'blog',
	CATEGORY = 'category',
	DEPARTMENT = 'department',
	REVIEWER = 'reviewer',
	TAG = 'tag'
}
